import { type Log } from "./log";

/**
 * What the Log Panel highlights. A click selects one specific row by its global
 * sequence; playback selects a timestamp, so every row sharing it highlights
 * together as the playhead reaches them (one timestamp can hold many rows).
 */
export type LogSelection =
  | { kind: "row"; sequence: number }
  | { kind: "time"; time: bigint };

/** Whether `log` renders as selected under the current selection. */
export function isRowSelected(
  log: Log | undefined,
  selection: LogSelection | undefined,
): boolean {
  if (log === undefined || selection === undefined) {
    return false;
  }
  return selection.kind === "row"
    ? log.sequence === selection.sequence
    : log.time === selection.time;
}
